

var _squid = require('squid');

var _auth = require('xo-models/src/auth');

var _checkout = require('xo-models/src/checkout');

require('xo-tray-height/dist/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoInstallmentOptions', function () {
    return {
        template: _template2['default'],

        scope: {
            token: '=?',
            doneFn: '=?',
            cardNumber: '=?'
        },

        controller: ['$scope', function ($scope) {

            (0, _squid.$populate)($scope, {
                auth: _auth.$AuthModel.instance()
            }).then(function () {

                if ($scope.auth.logged_in) {

                    // Installment support for authenticated user
                    (0, _squid.$populate)($scope, {
                        checkoutSession: _checkout.$CheckoutSessionModel.instance($scope.token)
                    }).then(function () {
                        $scope.cardInfo = $scope.checkoutSession.plan.sources[0];
                        $scope.installments = $scope.checkoutSession.installments;
                    });
                } else {
                    // Installment support added for not authenticated user, e.g. BR signup flow
                    var installmentsModel = _checkout.$InstallmentOptionsModel.instance($scope.token);

                    installmentsModel.save({
                        data: {
                            cc: $scope.cardNumber,
                            payee: _checkout.$CheckoutPayeeModel.instance($scope.token),
                            checkoutCart: _checkout.$CheckoutCartModel.instance($scope.token),
                            checkoutAppData: _checkout.$CheckoutAppDataModel.instance($scope.token)
                        },

                        success: function success(result) {
                            $scope.cardInfo = result.cardInfo;
                            $scope.installments = result.installment_options;
                        }
                    });
                }
            });

            $scope.onSelect = function (index) {
                var selectedInstallmentData = $scope.installments[index];

                $scope.installmentsModel = _checkout.$InstallmentOptionsModel.instance($scope.token);

                var param = {
                    term: selectedInstallmentData.term,
                    payment_value: selectedInstallmentData.monthly_payment.value,
                    payment_currency: selectedInstallmentData.monthly_payment.currency
                };

                if (selectedInstallmentData.total_cost) {
                    param.total_cost_value = selectedInstallmentData.total_cost.value;
                    param.total_cost_currency = selectedInstallmentData.total_cost.currency;
                }

                if (selectedInstallmentData.discount_amount) {
                    param.discount_value = selectedInstallmentData.discount_amount.value;
                    param.discount_currency = selectedInstallmentData.monthly_payment.currency;
                }

                if (selectedInstallmentData.discount_percentage) {
                    param.discount_percentage = selectedInstallmentData.discount_percentage;
                }

                return $scope.installmentsModel.action('select', {
                    data: param,

                    success: function success(result) {
                        if ($scope.auth.logged_in) {
                            $scope.checkoutSession.selectedInstallmentData = selectedInstallmentData;
                        }
                        $scope.doneFn(result);
                    }
                });
            };
        }]
    };
});

_squid.$populate;

_auth.$AuthModel;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutPayeeModel;

_checkout.$CheckoutSessionModel;

_checkout.$InstallmentOptionsModel;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/installment-options/directive.js
// module id = ../node_modules/xo-wallet-components/src/installment-options/directive.js
// module chunks = 0